import React from 'react'
import { observer } from 'mobx-react'
import { Blocker } from 'react-router'
import { BulkActionStore } from '@App/stores/search/bulk-action-store'
import { PaginationBody } from '@Entities/pagination'
import ModalPortal from '@Components/Popups/ModalPortal'
import BulkActionLeavePageConfirmationPopup from '@Components/Popups/ConfirmationPopup/BulkActionLeavePageConfirmationPopup'

interface BulkActionLeavePageModalProps {
    store: BulkActionStore<string, string>
    runSearch: (pagination?: PaginationBody) => Promise<void>
    blocker: Blocker
    bulkActionLabel?: string
}

const BulkActionLeavePageModal = observer(
    ({ store, runSearch, blocker, bulkActionLabel }: BulkActionLeavePageModalProps) => (
        <ModalPortal isOpen={store.isLeavePageModalOpen}>
            <BulkActionLeavePageConfirmationPopup
                runSearch={runSearch}
                blocker={blocker}
                bulkActionStore={store}
                bulkActionLabel={bulkActionLabel}
            />
        </ModalPortal>
    )
)

export default BulkActionLeavePageModal
